import { motion } from 'framer-motion';
import { IMAGES } from '../../constants/images';

export const AboutHero = () => (
  <section className="py-24 bg-[#f8fafc]" data-testid="about-hero">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="grid lg:grid-cols-2 gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
        >
          <span className="inline-block px-4 py-2 bg-white rounded-full text-sm font-medium text-[#3b5998] mb-6 shadow-sm">
            About Us
          </span>
          <h1 className="font-heading text-4xl sm:text-5xl font-semibold text-[#0f172a] leading-tight mb-6">
            Trusted Financial Consultancy
            <span className="gradient-text block">Since 2014</span>
          </h1>
          <p className="text-lg text-[#64748b] leading-relaxed mb-6">
            Thesaurus of Finance is a business consultancy firm providing expert guidance 
            in Finance and Government Subsidies. Led by experienced Chartered Accountants 
            and industry professionals, we have established ourselves as a reliable partner 
            for businesses seeking financial growth.
          </p>
          <p className="text-[#64748b] leading-relaxed">
            Our D2D model — Documentation to Disbursement — ensures complete, 
            end-to-end support throughout your financial journey. We take pride in 
            our transparent approach and commitment to delivering results.
          </p>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, x: 30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <img
            src={IMAGES.foundersCover}
            alt="Our Founders"
            className="rounded-2xl shadow-2xl w-full"
          />
        </motion.div>
      </div>
    </div>
  </section>
);
